import { Box, Card, CardContent, IconButton, Typography, Button } from "@mui/material";
import { ChevronLeft, ChevronRight, Today } from "@mui/icons-material";
import styles from "../Exams/ExamsCalendar.module.css";
import { getWeekStart } from "./CalendarUtils";
import { Vocabulary } from "../../Utils/Vocabulary";

interface ICalendarHeaderProps {
  title: string;
  currentDate: Date;
  onNavigate: (direction: "prev" | "next") => void;
  onToday?: () => void;
  children?: React.ReactNode;
}

export default function CalendarHeader({
  title,
  currentDate,
  onNavigate,
  onToday,
  children,
}: ICalendarHeaderProps) {
  // Calculate week range
  const weekStart = getWeekStart(currentDate);
  const weekEnd = new Date(weekStart);
  weekEnd.setDate(weekEnd.getDate() + 6);

  const getWeekDisplay = () => {
    const startDay = weekStart.getDate();
    const endDay = weekEnd.getDate();
    const month = weekEnd.toLocaleDateString("ro-RO", { month: "long" });
    const year = weekEnd.getFullYear();

    return `${startDay} - ${endDay} ${month} ${year}`;
  };

  return (
    <Card className={styles.headerCard}>
      <CardContent className={styles.headerContent}>
        <Typography variant="h3" className={styles.title}>
          {title}
        </Typography>

        <Box className={styles.controlsContainer}>
          {children}

          <Box className={styles.navigationContainer}>
            <IconButton
              className={styles.navButton}
              onClick={() => onNavigate("prev")}
            >
              <ChevronLeft />
            </IconButton>

            <Typography variant="h6" className={styles.dateDisplay}>
              {getWeekDisplay()}
            </Typography>

            <IconButton
              className={styles.navButton}
              onClick={() => onNavigate("next")}
            >
              <ChevronRight />
            </IconButton>

            {onToday && (
              <Button
                variant="outlined"
                size="small"
                startIcon={<Today />}
                onClick={onToday}
                sx={{ ml: 2 }}
              >
                {Vocabulary.today}
              </Button>
            )}
          </Box>
        </Box>

        
      </CardContent>
    </Card>
  );
}